interface StickyComponent extends React.HtmlHTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const StickyComponent = ({
  children,
  className,
  ...props
}: StickyComponent) => {
  return (
    <div
      className={`sticky top-0 left-0 z-50 -mt-4 w-full ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default StickyComponent;
